import React from 'react';
import { Skeleton } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import { FEATURE } from '~/common/enums/feature.enum';
import {
  SlideshowCard,
  SlideshowCardSkeleton,
} from '~/domains/auth/components/SignUpSlideshow/components/Slideshow/SlideshowCard';
import useGetSlide from '~/domains/cms/slideshows/signup/useGetSlide';
import DefaultSlideshowImage from '~/domains/auth/components/SignUpSlideshow/components/Slideshow/DefaultSlideshowImage';
import { useIsTablet } from '~/domains/common/hooks/mediaQueries';
import ContestCard from '~/domains/contest/domains/common/components/ContestCard/ContestCard';
import { useIsFeatureEnabled } from '~/hooks/useIsFeatureEnabled';

import useIsShouldSkipKycAfterSignUp from '../SignUpSteps/useIsShouldSkipKycAfterSignUp';

import useStyles from './SignUpSlideshow.styles';
import Slideshow from './components/Slideshow/Slideshow';


function SignUpSlideshow() {
  const { classes, cx } = useStyles();
  const isTablet = useIsTablet();
  const { t } = useTranslation('auth');

  const { data: slides, isLoading } = useGetSlide();
  const { contest, isShouldSkipKycAfterSignUpLoading } = useIsShouldSkipKycAfterSignUp();
  const isSignupContestCardEnabled = useIsFeatureEnabled(FEATURE.ENABLE_SIGNUP_CONTEST_CARD);

  if (isSignupContestCardEnabled && isShouldSkipKycAfterSignUpLoading) {
    return (
      <div className={classes.contestCardContainer}>
        <Skeleton height={74} width={380} />
        <Skeleton height={300} width={440} />
      </div>
    );
  }

  if (isSignupContestCardEnabled && contest.data) {
    return (
      <div className={classes.contestCardContainer}>
        <SlideshowCard title={t('signUpContestCard.title')}>
          <ContestCard contest={contest.data} isStatic isBannerEnabled />
        </SlideshowCard>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className={classes.container}>
        <SlideshowCardSkeleton />
      </div>
    );
  }

  return !slides || !slides.length ? (
    <div className={cx(classes.defaultContainer, classes.container)}>
      <DefaultSlideshowImage size={isTablet ? 320 : 484} />
    </div>
  ) : (
    <div className={classes.container}>
      <Slideshow>
        {slides.map((slide) => (
          <Slideshow.Slide key={slide.id} sx={{ minHeight: isTablet ? '600px' : '720px' }}>
            <SlideshowCard {...slide} />
          </Slideshow.Slide>
        ))}
      </Slideshow>
    </div>
  );
}

export default SignUpSlideshow;
